import { SESSION_COMPANY } from 'utils/constants'

const selectedCompany = JSON.parse(localStorage.getItem(SESSION_COMPANY))

const state = selectedCompany
  ? { selectedCompany }
  : { selectedCompany: null }

const actions = {
  updateSelectedCompany ({ commit }, company) {
    localStorage.setItem(SESSION_COMPANY, JSON.stringify(company))
    commit('updateSelectedCompany', company)
  },

  clearSelectedCompany ({ commit }) {
    localStorage.removeItem(SESSION_COMPANY)
    commit('clearSelectedCompany')
  }
}

const mutations = {
  updateSelectedCompany (state, company) {
    state.selectedCompany = company
  },

  clearSelectedCompany (state) {
    state.selectedCompany = null
  }
}

const company = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default company
